module.exports = __webpack_public_path__ + "img/excel.73faa4c9.svg";